/** @format */

import React from "react";
import { QueryProps } from "../../resourceIndexUI/ResourcesIndexUI";
import { AllParams } from "../ResourcesFilter";
import { ReactComponent as Square } from "bootstrap-icons/icons/square.svg";
import { ReactComponent as CheckSquare } from "bootstrap-icons/icons/check-square-fill.svg";
import { useTranslation } from "react-i18next";
import { filterResources } from "../utils";
import { ResourceReference } from "../../../../types";

type Props = {
  isLoading?: boolean;
  query: QueryProps;
  allParams: AllParams;
  handleQueryItemClick: (
    thisValue: string,
    thisQueryType: keyof QueryProps,
  ) => void;
  resources: ResourceReference[] | undefined;
};

const CatFilter: React.FC<Props> = ({
  isLoading,
  allParams,
  handleQueryItemClick,
  query,
  resources,
}) => {
  const { t: _ } = useTranslation();

  let allCats = resources
    ? [...allParams.cats]?.map((c) => {
        const count = filterResources([...resources], "cats", query).filter(
          (r) => r.Object.categories?.includes(c.title),
        ).length;
        if (count !== c.count) {
          return { ...c, count: count };
        }
        return c;
      })
    : [...allParams.cats];

  return (
    <>
      {(!!allCats?.length || isLoading) && (
        <div className="card shadow mb-3">
          <div className="card-body" key="categories-filter">
            <h5>
              {_("Category")} / {_("Unit")}
            </h5>
            {isLoading &&
              Array(4)
                .fill(null)
                .map((u, i) => (
                  <button
                    key={`cat${i}`}
                    className={`w-100 btn btn-light text-start py-0 mb-2`}
                  >
                    <Square />
                    &emsp;<span className="placeholder col-3"></span>{" "}
                    <span className="float-end placeholder col-1"></span>
                  </button>
                ))}
            {allCats
              ?.sort((a, b) => (a.title < b.title ? -1 : 1))
              .map((_cat, index) => (
                <button
                  onClick={() => handleQueryItemClick(_cat.title, "cats")}
                  key={_cat.title + index}
                  className={`w-100 btn btn-light text-start py-0 mb-2 text-capitalize`}
                >
                  {/* {cat === _cat.title ? <CheckSquare /> : <Square />} */}
                  {query.cats?.includes(_cat.title) ? (
                    <CheckSquare />
                  ) : (
                    <Square />
                  )}
                  &emsp;{_cat.title}
                  <span className="text-muted float-end">{_cat.count}</span>
                </button>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default CatFilter;
